import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ItemParticipantComponent} from "../../classes/plugins/ParticipantPlugin/item-participant/item-participant.component";
import {ParticipantsService} from "../../classes/plugins/ParticipantPlugin/service/participants.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
declare const Yiit;

@Component({
  selector: 'app-item-participant',
  templateUrl: './item-participant.component.html',
  styleUrls: ['./item-participant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemParticipantComponent21 extends ItemParticipantComponent{
}
